import React, { Component } from 'react';
import { connect } from 'dva';
import { Row, Col, Spin, message } from 'antd';
import Container from '../../../../../components/Container';
import MessageList from './component/messageList';
import LeaveWordList from './component/leaveWordList';
import MyPagination from './component/pagination';
import { getAppCode } from '../../utils/utils';
import styles from './index.less';

@connect(({ leaveWord }) => ({
  ...leaveWord,
}))
class LeaveWord extends Component {
  constructor(props) {
    super(props);

    this.state = {
      messageListData: [],
      messagePagination: {},
      leaveWordListData: [],
      leaveWordPagination: {},
      newsId: '',
      isAudit: null,
      leaveWordPageNum: 0,
      replyContent: '',
      noData: false,
      nowItem: [],
      nowIndex: 0,
      nowPageNum: 0,
      nowPageSize: 1,
    };
  }

  componentDidMount() {
    this.getMessage(0, 10, 0);
    this.getAuditConfig();
  }

  getAuditConfig = () => {
    const { dispatch } = this.props;
    dispatch({
      type: 'leaveWord/fetchLeaveWordConf',
      params: {
        appCode: getAppCode(),
      },
    }).then(result => {
      this.setState({ isAudit: result.isAudit });
    });
  };

  getMessage = (pageNum, pageSize, index) => {
    const { dispatch } = this.props;
    this.setState({
      nowPageNum: pageNum,
      nowPageSize: pageSize,
    });
    dispatch({
      type: 'leaveWord/fetchTextList',
      params: {
        pageNum,
        pageSize,
        appCode: getAppCode(),
      },
    }).then(result => {
      const { data, pagination } = result;
      this.setState({
        messageListData: this.convertData(data, index || 0),
        messagePagination: pagination,
        noData: !data.length > 0,
      });
      if (data.length > 0) {
        this.getLeaveWord(data[index || 0].id, 0, 10);
        this.setState({
          nowItem: data[index || 0],
        });
      }
    });
  };

  getLeaveWord = (newsId, pageNum, pageSize) => {
    const { dispatch } = this.props;
    this.setState({
      newsId,
      leaveWordPageNum: pageNum,
    });
    dispatch({
      type: 'leaveWord/fetchLeaveWordList',
      params: {
        newsId,
        pageNum,
        pageSize,
      },
    }).then(result => {
      const { data, pagination } = result;
      this.setState({
        leaveWordListData: this.convertData(data),
        leaveWordPagination: pagination,
      });
    });
  };

  convertData = (data, index) => {
    data.forEach((item, num) => {
      if (index === num) {
        item.checked = true;
        this.setState({
          nowIndex: index,
        });
      } else {
        item.checked = false;
      }
    });
    return data;
  };

  changeMessage = (item, index) => {
    const { messageListData } = this.state;
    this.setState({
      messageListData: this.convertData(messageListData, index),
      nowItem: item,
    });
    this.getLeaveWord(item.id, 0, 10);
  };

  // 改变是否留言状态
  changeCanLeave = checked => {
    const { dispatch } = this.props;
    const { newsId } = this.state;
    const { nowPageNum, nowPageSize, nowIndex } = this.state;
    dispatch({
      type: 'leaveWord/fetchCanLeave',
      params: {
        newsId,
        canLeave: checked ? 1 : 0,
        appCode: getAppCode(),
      },
    }).then(res => {
      const { nowItem } = this.state;
      const { canLeaveWords } = nowItem;
      this.setState(
        {
          nowItem: { ...nowItem, canLeaveWords: !canLeaveWords },
        },
        () => {
          this.getMessage(nowPageNum, nowPageSize, nowIndex);
        }
      );
    });
  };

  addReply = item => {
    const { leaveWordListData } = this.state;
    leaveWordListData.forEach(ele => {
      if (item.id === ele.id) {
        item.checked = !item.checked;
      }
    });
    this.setState({ leaveWordListData });
  };

  deleteLeaveWord = item => {
    const { newsId, leaveWordPageNum } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: 'leaveWord/fetchDelLeaveWord',
      params: {
        id: item.id,
      },
    }).then(result => {
      this.getLeaveWord(newsId, leaveWordPageNum, 10);
    });
  };

  changeAudit = item => {
    if (item.isAudit === 0) {
      this.leaveWordApprove(item.id, item);
    } else {
      this.leaveWordCancelApprove(item.id, item);
    }
  };

  leaveWordApprove = id => {
    const { newsId, leaveWordPageNum } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: 'leaveWord/fetchLeaveWordApprove',
      params: {
        id,
      },
    }).then(result => {
      this.getLeaveWord(newsId, leaveWordPageNum, 10);
    });
  };

  leaveWordCancelApprove = id => {
    const { newsId, leaveWordPageNum } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: 'leaveWord/fetchLeaveWordCancelApprove',
      params: {
        id,
      },
    }).then(result => {
      this.getLeaveWord(newsId, leaveWordPageNum, 10);
    });
  };

  changeReplyContent = e => {
    this.setState({ replyContent: e.target.value });
  };

  encodeEmoji = str => {
    const patt = /[\ud800-\udbff][\udc00-\udfff]/g;
    const str1 = str.replace(/%/g, '%2525');
    // 检测utf16字符正则
    const str2 = str1.replace(patt, char => {
      // const H, L, code;
      if (char.length === 2) {
        return encodeURIComponent(encodeURIComponent(char));
      }
      return char;
    });
    return str2;
  };

  saveLeaveWord = item => {
    const { replyContent, newsId, leaveWordPageNum } = this.state;
    const { dispatch } = this.props;
    if (!replyContent.trim().length) {
      message.warning('请输入回复内容');
      return;
    }
    const params = {
      msg: this.encodeEmoji(replyContent),
      newsId,
      parentId: item.id,
    };
    dispatch({
      type: 'leaveWord/fetchReplyLeaveWord',
      params,
    }).then(result => {
      this.setState({
        replyContent: '',
      });
      this.getLeaveWord(newsId, leaveWordPageNum, 10);
    });
  };

  changeLeaveWordPage = noop => {
    const { newsId } = this.state;
    this.getLeaveWord(newsId, noop, 10);
  };

  render() {
    const { spinning } = this.props;
    const {
      messageListData,
      messagePagination,
      leaveWordListData,
      leaveWordPagination,
      isAudit,
      noData,
      nowItem,
    } = this.state;
    return (
      <Container breStates={!0} version={2}>
        <div className={styles.leaveWordPage}>
          <Spin spinning={spinning}>
            <div>
              <section className={styles.content}>
                <Row className="border">
                  <Col span={6} className={noData ? 'left noDataLeft' : 'left'}>
                    <MessageList
                      messageListData={messageListData}
                      messagePagination={messagePagination}
                      changeMessage={this.changeMessage}
                      getMessage={this.getMessage}
                      noData={!noData}
                    />
                  </Col>
                  <Col span={18} className="right">
                    <LeaveWordList
                      leaveWordListData={leaveWordListData}
                      isAudit={isAudit}
                      addReply={this.addReply}
                      changeAudit={this.changeAudit}
                      deleteLeaveWord={this.deleteLeaveWord}
                      changeReplyContent={this.changeReplyContent}
                      saveLeaveWord={this.saveLeaveWord}
                      noData={noData}
                      changeCanLeave={this.changeCanLeave}
                      nowItem={nowItem}
                    />
                  </Col>
                </Row>
              </section>
              <section className={styles.pagination}>
                <MyPagination
                  type="leaveWord"
                  leaveWordPagination={leaveWordPagination}
                  changeLeaveWordPage={this.changeLeaveWordPage}
                />
              </section>
            </div>
          </Spin>
        </div>
      </Container>
    );
  }
}

export default LeaveWord;
